import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-2 h-full" }

import {
  onMounted,
} from 'vue';
import ChatHistoryList from '@/components/ChatInterface/ChatHistory/ChatHistoryList.vue';
import CustomLoader1 from '@/components/Helper/Loader/CustomLoader1.vue';
import {
  type ConversationThreadService,
  getConversationThreadService,
} from '@/services/ConversationThreadService';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatHistoryUi',
  setup(__props) {


let conversationThreadService: ConversationThreadService;

const utilStore = useStore.util;
const conversationHistoryStore = useStore.conversationHistory;
const conversationThreadStore = useStore.conversationThread;

async function onSingleHistoryClick(
  conversationId: string,
): Promise<void> {
  conversationThreadService.clearHistoryAssociatedFields();

  // history chat
  utilStore.isHistoryChat = true;
  conversationThreadStore.uuid = conversationId;
  conversationHistoryStore.showHistoryList = false;
}

onMounted(async () => {
  conversationThreadService = getConversationThreadService();
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChatHistoryList, {
      class: _normalizeClass([
        _unref(utilStore).notification ? 'h-87' : 'h-99',
        { 'overflow-y-scroll': _unref(conversationHistoryStore).conversationList.length > 2 },
      ]),
      "onConversation:id": _cache[0] || (_cache[0] = ($event: any) => (onSingleHistoryClick($event)))
    }, null, 8, ["class"]),
    (_unref(conversationHistoryStore).isLoading)
      ? (_openBlock(), _createBlock(CustomLoader1, { key: 0 }))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _unref(conversationHistoryStore).showHistoryList]
  ])
}
}

})